import { render, staticRenderFns } from "./EssaySendFileForm.vue?vue&type=template&id=6c1e56ae&scoped=true&"
import script from "./EssaySendFileForm.vue?vue&type=script&lang=ts&"
export * from "./EssaySendFileForm.vue?vue&type=script&lang=ts&"
import style0 from "./EssaySendFileForm.vue?vue&type=style&index=0&id=6c1e56ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1e56ae",
  null
  
)

export default component.exports